@import '_base.css';

:root {
  --spw-ds-primary: var(--spw-color-themes-light-blue-light-blue-600);
  --spw-ds-variant: var(--spw-color-themes-light-blue-light-blue-800);
  --spw-ds-active: var(--spw-color-themes-light-blue-light-blue-900);
  --spw-ds-cta-outlined-bg-hover: var(--spw-color-themes-light-blue-light-blue-50);
  --spw-ds-cta-outlined-stroke-hover: var(--spw-color-themes-light-blue-light-blue-700);
  --spw-ds-cta-outlined-bg-active: var(--spw-color-themes-light-blue-light-blue-100);
  --spw-ds-cta-outlined-stroke-active: var(--spw-color-themes-light-blue-light-blue-800);
}
